import { render } from "./ServicesMetadataGroups.vue?vue&type=template&id=11c2e337&scoped=true"
import script from "./ServicesMetadataGroups.vue?vue&type=script&lang=js"
export * from "./ServicesMetadataGroups.vue?vue&type=script&lang=js"

import "./ServicesMetadataGroups.vue?vue&type=style&index=0&id=11c2e337&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c2e337"]])

export default __exports__